import clsx from "clsx";
import moment from "moment";
import Moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useAsyncDebounce, useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import {
  getDeskeraTenantDetails,
  migrateBrightPearlDataForInventoryTransactions,
  migrateBrightPearlInventoryTransactionsToDeskera,
  updateBrightPearlInventoryTransactionsValue,
} from "src/api";
import ArrowClockwise from "src/assets/ArrowClockwise";
import ArrowRight from "src/assets/ArrowRight";
import CloseIcon from "src/assets/Close";
import EmptyTray from "src/assets/EmptyTray";
import ForwardRight from "src/assets/ForwardRight";
import UpArrowIcon from "src/assets/UpArrow";
import Alert from "src/components/Alert";
import SearchBar from "src/components/Filters/SearchBar";
import SearchFilter from "src/components/Filters/SearchFilter";
import SyncByDateRange from "src/components/SyncByDateRange";
import SyncStatus from "src/components/SyncStatus";
import { loadAccounts, loadConfig, loadInventoryTransactions } from "src/redux/actions/brightpearl";
import { addToast } from "src/redux/actions/toasts";
import { startDateFormat, yearFirstDateFormat } from "src/utils/Constants";
import customSelectTheme from "src/utils/selectTheme";
import { getQueryParams, Utility } from "src/utils/Utility";

function InventoryTransactions() {
  const inventoryTransactions = useSelector((state) => state.brightpearl.inventoryTransactions);
  const data = useMemo(
    () => (inventoryTransactions.data.content ? inventoryTransactions.data.content : []),
    [inventoryTransactions]
  );
  const fullData = useMemo(() => inventoryTransactions.data, [inventoryTransactions]);
  const dispatch = useDispatch();
  const [status, setStatus] = useState([]);
  const job = useSelector((state) => state.brightpearl.job);
  const [triggered, setTriggered] = useState(false);
  const [triggered1, setTriggered1] = useState(false);
  const [hover, setHover] = useState(false);
  const [value, setValue] = useState();
  const [search, setSearch] = useState(null);
  // const [params, setParams] = useState({});
  // const [pageCount, setPageCount] = useState(0);
  // const [pageSize, setPageSize] = useState(10);
  // const [pageIndex, setPageIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const brightPearlConfig = useSelector((state) => state.brightpearl.config);
  const [query, setQuery] = useState({});
  const accounts = useSelector((state) => state.brightpearl.accounts);

  const [updateRow, setUpdateRow] = useState();
  const [updatedAmount, setUpdatedAmount] = useState(0);
  const [syncStausFilter, setSyncStausFilter] = useState("");
  const [syncDateRange, setSyncDateRange] = useState(undefined);
  const [showSyncFromDate, setShowSyncFromDate] = useState("NONE");
  const tenantInfo = useSelector((state) => state.auth.user);
  const userInfo = useSelector((state) => state.auth.user);
  const onFilter = (query) => {
    const search = encodeURIComponent(query["search"] ?? "");
    setSearch(search);
    gotoPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Movement Type",
        accessor: "movementType",
      },
      {
        Header: "Transaction Date",
        accessor: "stockTransDate",
        Cell: ({ cell: { value } }) => {
          const date = Utility.isNotEmpty(value)
            ? Utility.convertToDate(value.split("T")[0], yearFirstDateFormat)
            : "";
          return (
            <>
              <span>{date}</span>
            </>
          );
        },
      },
      {
        Header: "Product Id",
        accessor: "productDocumentSequenceCode",
      },
      {
        Header: "Product Name",
        accessor: "productName",
      },
      {
        Header: "Transaction Type",
        accessor: "transactionType",
      },
      {
        Header: "Quantity",
        accessor: "quantity",
      },
      {
        Header: "Transaction Number",
        accessor: "transactionNo",
      },
      {
        Header: "Contact Name",
        accessor: "contactName",
      },
      {
        Header: "Rate/Value",
        accessor: "value",
      },
      {
        Header: "Source",
        accessor: "source",
      },

      {
        Header: "Sync Status",
        accessor: "syncStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.syncStatus}
              reason={row.original.reason}
              id={row.original.cartCustomerId}
            />
          );
        },
        disableGlobalFilter: true,
      },
      {
        Header: "Sync Remark",
        accessor: "syncRemark",
        Cell: ({ cell: { row } }) => {
          return row.original.syncRemark;
        },
      },
    ],
    [accounts]
  );

  const handleShow = (cell) => {
    setUpdateRow(cell?.row?.original);
  };

  async function updateInventoryTransactions() {
    if (!updateRow || !updateRow.id || updatedAmount === 0) {
      return;
    }
    setTriggered(true);
    const requestBody = {
      totalAmount: updatedAmount,
    };
    try {
      await updateBrightPearlInventoryTransactionsValue(updateRow.id, requestBody);
      dispatch(
        addToast({
          type: "success",
          title: "Success",
          message: "Sync job completed",
        })
      );
      setTriggered(false);
      setUpdateRow();
      setUpdatedAmount(0);
      dispatch(loadInventoryTransactions(pageSize, pageIndex, syncStausFilter));
    } catch (err) {
      setTriggered(false);
    }
  }

  function inventoryTransactionsAmoutUpdate() {
    return (
      <div className="d-flex">
        <div
          className="vw-100 vh-100 d-flex justify-content-center align-items-center"
          style={{
            zIndex: 99,
            position: "absolute",
            top: 0,
            left: 0,
            background: "rgba(0, 0, 0, 0.4)",
          }}
        >
          <div className="card dk-card dk-card-shadow d-flex" style={{ minWidth: "30%" }}>
            <div className="card-body d-flex flex-column" style={{ maxWidth: 550 }}>
              <div className="card-body d-flex flex-column">
                <div className="form-group">
                  <div className="text-muted mb-3" aria="label">
                    <b>Enter rate/value for Brightpearl inventory transaction</b>
                  </div>
                  <input
                    type="number"
                    className="form-control"
                    value={updatedAmount}
                    onChange={(e) => setUpdatedAmount(e.target.value)}
                  />
                </div>

                <div>
                  <span data-tip="React-tooltip" data-for={updateRow} className="text-muted">
                    *The rate/value of this transaction is zero and system can not create{" "}
                    {updateRow?.transactionType ? updateRow?.transactionType : "document"} with zero
                    rate/value. Please update the rate/value.
                  </span>
                </div>
              </div>
              <div className="d-flex flex-row-reverse mt-3">
                <button
                  className="btn dk-btn font-weight-bold text-success border border-success px-4"
                  onClick={(e) => {
                    updateInventoryTransactions();
                  }}
                  disabled={updatedAmount && Number(updatedAmount) > 0 && !triggered ? false : true}
                >
                  <span>Update</span>
                </button>
                <button
                  className="btn dk-btn mr-2 px-3 font-weight-bold text-muted border border-secondary"
                  onClick={(e) => {
                    setUpdateRow(null);
                    setUpdatedAmount(0);
                  }}
                  disabled={triggered}
                >
                  <span className="svg-icon svg-baseline mr-2 svg-disabled">
                    <CloseIcon />
                  </span>
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy },
    prepareRow,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
      },
      pageCount: fullData.totalPages,
      manualPagination: true,
      autoResetPage: false,
      manualSortBy: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const colummsLength = columns.length;
  const dataLength = data.length;
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  function handleChange(e) {
    e.preventDefault();
    setValue(e.target.value);
    onChange(e.target.value);
  }

  const pageSizeOptions = [
    {
      value: 10,
      label: "10",
    },
    {
      value: 20,
      label: "20",
    },
    {
      value: 30,
      label: "30",
    },
  ];

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      minWidth: "230px",
      marginLeft: "2px",
    }),
  };

  const SOURCE_OPTIONS = [
    {
      value: "BRIGHTPEARL",
      label: "Brightpearl",
    },
    {
      value: "DESKERA",
      label: "Deskera",
    },
    {
      value: "BOTH",
      label: "Both",
    },
  ];

  function handleQueryUpdate(key, value) {
    if (Utility.isEmpty(value)) {
      setQuery((prev) => {
        delete prev[key];
        return { ...prev };
      });
    } else {
      setQuery((prev) => {
        return { ...prev, [key]: value };
      });
    }
  }

  const statusOptions = [
    {
      value: "SUCCESSFUL",
      label: "Successful",
    },
    {
      value: "FAILED",
      label: "Failed",
    },
    {
      value: "PENDING",
      label: "Pending",
    },
  ];
  const updateSelectedStatus = (options) => {
    var selected = [];
    options.forEach((element) => {
      selected.push(element.value);
    });
    setStatus(selected);
  };

  useEffect(() => {
    dispatch(loadConfig());
    dispatch(loadInventoryTransactions());
    if (accounts?.data?.length === 0) {
      dispatch(loadAccounts());
    }
    const bbDate = tenantInfo?.bookBeginningStartDate;
    if (bbDate) {
      setSyncDateRange(new Date(bbDate));
    }
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [fullData]);

  const config = useSelector((state) => state.brightpearl.config);

  const refreshData = () => {
    if (!triggered) {
      setTriggered(true);
      setPageSize(pageSize);
      setLoading(true);
      const queryParams = getQueryParams(query);
      dispatch(loadInventoryTransactions(pageSize, pageIndex, status, sortBy, search, queryParams));
      setTriggered(false);
    }
  };

  useEffect(() => {
    refreshData();
  }, [status, pageSize, pageIndex, query, sortBy, search]);

  async function handleSyncSubmit() {
    setTriggered(true);
    let bbd;

    try {
      const tenantDetails = await getDeskeraTenantDetails();
      bbd = tenantDetails.bookBeginningStartDate;

      const body = { 
          startDate: Moment(bbd).format(startDateFormat),
          fromDate: Moment(syncDateRange.startDate).format(startDateFormat),
          toDate: Moment(syncDateRange.endDate).format(startDateFormat)
      };
      const resp = await migrateBrightPearlDataForInventoryTransactions(body);

      dispatch(
        addToast({
          type: "success",
          title: "Success",
          message: "Sync job started",
        })
      );
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        dispatch(
          addToast({
            type: "danger",
            title: "Failure",
            message: err.response.data.message,
          })
        );
      } else {
        dispatch(
          addToast({
            type: "danger",
            title: "Failure",
            message: "An unexpected error occurred",
          })
        );
      }
    } finally {
      dispatch(loadInventoryTransactions(pageSize, pageIndex, status, sortBy, search, null));
      setTriggered(false);
    }
  }

  async function handleBrightPearlInvSyncSubmit() {
    setTriggered1(true);
    let bbd;

    try {
      const tenantDetails = await getDeskeraTenantDetails();
      bbd = tenantDetails.bookBeginningStartDate;

      const body = { 
        startDate: Moment(bbd).format(startDateFormat),
        fromDate: Moment(syncDateRange.startDate).format(yearFirstDateFormat),
        toDate: Moment(syncDateRange.endDate).format(yearFirstDateFormat)
      };
      const resp = await migrateBrightPearlInventoryTransactionsToDeskera(body);

      dispatch(
        addToast({
          type: "success",
          title: "Success",
          message: "Sync job started",
        })
      );
    } catch (err) {
      console.error("Error in handleBrightPearlInvSyncSubmit:", err);

      dispatch(
        addToast({
          type: "danger",
          title: "Failure",
          message: err.response?.data?.message || "An unexpected error occurred",
        })
      );
    } finally {
      dispatch(loadInventoryTransactions(pageSize, pageIndex, status, sortBy, search, null));
      setTriggered1(false);
    }
  }

  function Warning() {
    return <div className="bg-chip-blue border-radius-l p-h-s ml-s p-v-xs">Syncing...</div>;
  }

  const  getDateRange = () =>{

    return<> {(showSyncFromDate === 'BRIGHTPEARL' ||showSyncFromDate === 'DESKERA') && (
      <SyncByDateRange
        selectedDate={syncDateRange}
        onSelect={(newDate) => {
          const bbDate = tenantInfo?.bookBeginningStartDate;
          const bookBeginningStartDate = moment(bbDate, yearFirstDateFormat).toDate();

          if (
            (newDate?.startDate && newDate.startDate < bookBeginningStartDate) ||
            (newDate?.endDate && newDate.endDate <= bookBeginningStartDate)
          ) {
            dispatch(
              addToast({
                type: "danger",
                title: "Failure",
                message:
                  "Selected date should be greater than the Book Beginning Start Date.",
              })
            );
            setSyncDateRange({ startDate: null, endDate: null });
            return;
          }
          setSyncDateRange(newDate);
        }}
        syncSubmit={()=>{
          if(showSyncFromDate === 'BRIGHTPEARL'){
            handleBrightPearlInvSyncSubmit();
            setShowSyncFromDate("NONE");
          }else if(showSyncFromDate === 'DESKERA'){
            handleSyncSubmit();
            setShowSyncFromDate("NONE");
          }
        }}
        onClose={(e) => {
          setShowSyncFromDate("NONE");
        }}
      />
    )}</>
  }

  return (
    <div className="p-4">
      <h3 className="mb-3">Inventory Transactions</h3>
      {(!config.data || !config.data.syncEnabled) && (
        <Alert type="warning">
          Your synced inventory transactions will appear here. Please complete{" "}
          <Link to="/app/brightpearl" className="text-alert-warning">
            <u>Setup</u>
          </Link>{" "}
          before continuing.
        </Alert>
      )}
      <>
        <div className="d-flex flex-column mb-2 space-between">
          <div style={{ width: "auto" }}>
            <div className="d-flex flex-row align-items-center">
              <button
                className="btn border-radius-m p-v-s text-white bg-success"
                onClick={() => refreshData()}
                disabled={triggered}
                style={{ marginRight: "10px" }}
              >
                Refresh
              </button>
              {brightPearlConfig?.data?.syncInventoriesDeskeraToSource && (
                <button
                  className="btn border-radius-m p-v-s text-white bg-success"
                  onClick={() => setShowSyncFromDate("DESKERA")}
                  disabled={triggered && triggered1}
                  onMouseOver={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                >
                  <span className="svg-icon svg-baseline mr-2 svg-white">
                    {triggered ? (
                      <div class="spinner-border text-white spinner-border-sm" role="status"></div>
                    ) : (
                      <></>
                    )}
                  </span>
                  <span>Sync Deskera To Brightpearl</span>
                </button>
              )}
              {brightPearlConfig?.data?.syncInventoriesSourceToDeskera && (
                <button
                  className="btn border-radius-m p-v-s text-white bg-success"
                  onClick={() => setShowSyncFromDate("BRIGHTPEARL")}
                  disabled={triggered1 && triggered}
                  onMouseOver={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  style={{ marginLeft: "10px" }}
                >
                  <span className="svg-icon svg-baseline mr-2 svg-white">
                    {triggered1 ? (
                      <div class="spinner-border text-white spinner-border-sm" role="status"></div>
                    ) : (
                      <></>
                    )}
                  </span>
                  <span>Sync Brightpearl To Deskera</span>
                </button>
              )}
            </div>
          </div>
          {getDateRange()}
          <div style={{ verticalAlign: "center", marginTop: "8px" }}></div>
          <div style={{ marginLeft: "2px" }}>
            <form className="form-inline">
              {/* <span className="mr-2">Show by status:</span> */}
              <SearchFilter
                style={{ display: "flex", justifyContent: "end", width: "15rem" }}
                onFilterMap={onFilter}
              >
                <SearchBar
                  placeholder={`Search Inventories`}
                  inputStyle={{ width: "12rem" }}
                  style={{ minWidth: "15rem", margin: "2px" }}
                  queryKey={"search"}
                />
              </SearchFilter>
              <Select
                placeholder="Filter By Sync Status"
                className="mr-2 ml-2"
                styles={customStyles}
                options={statusOptions}
                menuPlacement="auto"
                onChange={(e) => {
                  updateSelectedStatus(e);
                  gotoPage(0);
                }}
                theme={customSelectTheme}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isSearchable={false}
                isMulti={true}
              />

              <Select
                placeholder="Filter By Source"
                className="mr-2"
                styles={customStyles}
                options={SOURCE_OPTIONS}
                menuPlacement="auto"
                onChange={(e) => {
                  if (e.value === "BOTH") {
                    handleQueryUpdate("source", null);
                  } else {
                    handleQueryUpdate("source", e.value);
                  }
                  gotoPage(0);
                }}
                theme={customSelectTheme}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isSearchable={false}
                isMulti={false}
              />
            </form>
          </div>
        </div>
        {updateRow && inventoryTransactionsAmoutUpdate()}
        <div className="card" style={{ overflowX: "auto" }}>
          <table className="table m-0 dk-table-hover dk-table" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps([
                        { className: column.className },
                        column.getSortByToggleProps(),
                      ])}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <span className="fs-r text-align-left fw-m fs-m text-gray cursor-hand">
                        {column.render("Header")}
                      </span>
                      <span
                        className={clsx(
                          "svg-icon svg-disabled svg-baseline",
                          !column.isSorted && "invisible",
                          column.isSorted && column.isSortedDesc && "svg-flipped"
                        )}
                      >
                        <UpArrowIcon />
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {!loading && dataLength === 0 && (
                <tr>
                  <td colSpan={colummsLength}>
                    <div className="d-flex flex-column align-items-center">
                      <span className="mt-3 svg-disabled" style={{ width: "50px", height: "50px" }}>
                        <EmptyTray />
                      </span>
                      <span className="mt-2 text-muted">No records were found.</span>
                    </div>
                  </td>
                </tr>
              )}
              {!loading &&
                page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps([{ className: cell.column.className }])}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
            </tbody>
            {loading && (
              <tr>
                <td colSpan={colummsLength}>
                  <div className="d-flex flex-column align-items-center">
                    <span className="mt-2 text-muted">Loading...</span>
                  </div>
                </td>
              </tr>
            )}
            {/* {loading && <label className="d-flex justify-content-center">Loading...</label>} */}
          </table>
        </div>
        <div className="d-flex flex-row-reverse align-items-center mt-3">
          <div className="d-flex flex-row align-items-center">
            <span className="mr-2">Max rows per page:</span>
            <Select
              placeholder="Page"
              className="page-selector"
              options={pageSizeOptions}
              value={pageSizeOptions.filter((option) => option.value === pageSize)}
              menuPlacement="auto"
              onChange={(e) => {
                setPageSize(Number(e.value));
              }}
              theme={customSelectTheme}
              components={{
                IndicatorSeparator: () => null,
              }}
              isSearchable={false}
            />
          </div>
          <div className="d-flex flex-row align-items-center mr-2">
            <button className="btn mr-2" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              <span
                className={clsx(
                  "svg-icon svg-baseline svg-flipped",
                  canPreviousPage ? "svg-black" : "svg-disabled"
                )}
              >
                <ForwardRight />
              </span>
            </button>
            <button className="btn mr-2" onClick={() => previousPage()} disabled={!canPreviousPage}>
              <span
                className={clsx(
                  "svg-icon svg-baseline svg-flipped",
                  canPreviousPage ? "svg-black" : "svg-disabled"
                )}
              >
                <ArrowRight />
              </span>
            </button>
            <span className="mr-2">
              {pageIndex + 1} / {Math.max(pageOptions.length, 1)}
            </span>
            <button className="btn mr-2" onClick={() => nextPage()} disabled={!canNextPage}>
              <span
                className={clsx(
                  "svg-icon svg-baseline",
                  canNextPage ? "svg-black" : "svg-disabled"
                )}
              >
                <ArrowRight />
              </span>
            </button>
            <button className="btn" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
              <span
                className={clsx(
                  "svg-icon svg-baseline",
                  canNextPage ? "svg-black" : "svg-disabled"
                )}
              >
                <ForwardRight />
              </span>
            </button>
          </div>
        </div>
      </>
    </div>
  );
}

export default InventoryTransactions;
